// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_GatewayToggleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_GatewayToggleInput — body for POST /subscriptions/gateways/toggle.
 *
 * Required:
 *   feature       (string) — e.g. 'subscriptions', 'ai_credit_topup'
 *   provider_code (string) — e.g. 'gatewaytest', 'stripe'
 *   enabled       (bool)   — true = enable, false = disable
 */
import { registerContract } from './validate'

export interface Subscriptions_GatewayToggleInput {
feature: string
provider_code: string
enabled: boolean
}

registerContract('Subscriptions_GatewayToggleInput', {
  feature:       { type: 'string',  required: true },
  provider_code: { type: 'string',  required: true },
  enabled:       { type: 'boolean', required: true },
})
